import request from '@/utils/request'

import qs from 'qs'


// 发送邮箱验证码
export const sendCodeAPI = (email) => {
  return request.post('/api/sendVerificationCode', qs.stringify({ email }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

// 注册
export const registerAPI = ({ email, code, password, username }) => {
  return request({
    url: '/api/reguser',
    method: 'POST',

    data: {
      username,
      password,
      email,
      code
    }
  })
}

// 登录
export const loginAPI = ({ email, password }) => {
  return request({
    url: '/api/login',
    method: 'POST',

    data: {
      email,
      password
    }
  })
}

// 忘记密码 - 发送重置验证码（仅已注册邮箱可用，验证码 3 分钟有效）
export const sendResetCodeAPI = (email) => {
  return request.post('/api/sendResetCode', qs.stringify({ email }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

/**
 * 忘记密码 - 校验验证码并重置密码
 * 成功后后端会清空该邮箱的验证码，同一验证码不可重复使用
 * @param {*} param0 { email: 邮箱, code: 6 位验证码, password: 新密码 }
 * @returns Promise对象
 */
export const resetPasswordAPI = ({ email, code, password }) => {
  return request({
    url: '/api/resetPassword',
    method: 'POST',

    data: {
      email,
      code,
      password
    }
  })
}

// 获取用户信息
export const getUserInfoAPI = () => {
  return request({
    url: '/my/userinfo'
  })
}

/**
 * 更新-用户基本资料（当前用于修改昵称）
 * 说明：身份一律由后端从 Token 解析，前端不传 id；密码变更走 updatePasswordAPI
 * @param {*} param0 { username: 昵称, email: 邮箱 }
 * @returns Promise对象
 */
export const updateUserInfoAPI = ({ username, email }) => {
  return request({
    url: '/my/userinfo',
    method: 'POST',
    data: {
      username,
      email
    }
  })
}

/**
 * 修改密码：后端会校验原密码是否正确，再用 bcrypt 加密写入新密码
 * @param {*} param0 { oldPassword: 原密码, newPassword: 新密码 }
 * @returns Promise对象
 */
export const updatePasswordAPI = ({ oldPassword, newPassword }) => {
  return request({
    url: '/my/password',
    method: 'POST',
    data: {
      oldPassword,
      newPassword
    }
  })
}

/**
 * 更新-偏好设置（当前支持 show_recent_visit：首页是否展示"最近去过的村子"）
 * @param {*} data { show_recent_visit: 0 | 1 }
 * @returns Promise对象
 */
export const updatePreferencesAPI = (data) => {
  return request({
    url: '/my/preferences',
    method: 'POST',
    data
  })
}

/**
 * 获取-网站分类
 * @returns Promise对象
 */
export const getCategoryListAPI = (userId) => {
  return request({
    url: '/my/website/getcategory/' + userId
  })
}

/**
 * 增加-网站分类
 * @param {*} param0 { cate_name: 文章分类名字, cate_alias: 文章分类别名 }
 * @returns Promise对象
 */
export const addCategoryAPI = ({ userId, name }) => {
  return request({
    url: `/my/website/addcategory/${userId}`,
    method: 'POST',
    data: {
      name
    }
  })
}

/**
 * 更新-网站分类
 * @param {*} param0 { id: 文章分类id, cate_name: 文章分类名字, cate_alias: 文章分类别名 }
 * @returns Promise对象
 */
export const updateCategoryAPI = ({ id, name }) => {
  return request({
    url: '/my/website/updatecategory',
    method: 'POST',
    data: {
      id,
      name
    }
  })
}

/**
 * 删除-分类
 * @param {*} id 要删除的-分类id
 * @returns Promise对象
 */
export const delCategoryAPI = (id) => {
  return request({
    url: `/my/website/deletecategory/${id}`,
    method: 'DELETE'
  })
}

// 获取banner
export const getBannerAPI = () => {
  return request({
    url: '/api/banner/getbanner/'
  })
}

// 获取用户布局
export const getUserLayoutAPI = (userId) => {
  return request({
    method: 'GET',
    url: '/my/userlayout/layout/' + userId
  })
}

// 保存修改后的用户布局
export const saveUserLayoutAPI = (userId, layoutData) => {
  return request({
    method: 'POST',
    url: '/my/userlayout/layout',
    data: {
      userId: userId,
      layoutData: layoutData
    }
  });
}

// 获取站村推荐的网站
export const getRecommendAPI = (userId) => {
  return request({
    url: '/my/recommend/getrecommend/' + userId
  })
}

// 记录访问:用户点击分类中的网站后,进入"最近去过的村子"
export const visitWebsiteAPI = (data) => {
  return request({
    url: '/my/recommend/visit',
    method: 'POST',
    data
  })
}

// 编辑站村推荐的网站
export const editRecommendAPI = (formData) => {
  return request({
    url: '/my/recommend/updaterecommend',
    method: 'POST',
    data: formData
  })
}


// 拖拽推荐的网站
export const saveRecommendLayoutAPI = (userId, updates) => {
  return request({
    method: 'POST',
    url: `/my/recommend/updateSortOrder/${userId}`,
    data: updates
  });
};


// 拖拽的网站
export const saveLayoutAPI = (updates) => {
  return request({
    method: 'POST',
    url: '/my/websiteall/updateSortOrder',
    data: updates
  });
};

/**
 * 获取-网站
 * @returns Promise对象
 */
export const getWebsiteListAPI = (categoryId) => {
  return request({
    url: `/my/websiteall/list/${categoryId}`
  })
}

/**
 * 获取-网站
 * @returns Promise对象
 */
export const getWebsiteAPI = (id) => {
  return request({
    url: '/my/websiteall/' + id,
    params: { id }
  })
}

/**
 * 增加-网站
 * @param {*} param0 { cate_name: 文章分类名字, cate_alias: 文章分类别名 }
 * @returns Promise对象
 */
export const addWebsiteAPI = ({ formData, categoryId }) => {
  return request({
    url: `/my/websiteall/add/${categoryId}`,
    method: 'POST',
    data: formData
  })
}

/**
 * 删除-网站
 * @param {*} id 要删除的-网站id
 * @returns Promise对象
 */
export const delWebsiteAPI = (id) => {
  return request({
    url: '/my/websiteall/delete/' + id,
    method: 'DELETE',
    params: {
      id
    }
  })
}

// 编辑网站
export const editWebsiteAPI = (formData) => {
  return request({
    url: '/my/websiteall/edit',
    method: 'POST',
    data: formData
  })
}

// 根据id获取对应的网站数据
export const getWebsiteIdAPI = (id) => {
  return request({
    url: `/my/websiteall/${id}`,
    params: { id }
  })
}

// 根据网址获取对应的网站数据
export const getWebsiteDataAPI = (url) => {
  return request({
    url: '/my/websiteall/getWebsiteData',
    params: { url }
  })
}
